export default "__VITE_ASSET__CNrHuonq__"